import { render, staticRenderFns } from "./ContributionPaymentSetup.vue?vue&type=template&id=745a9690&scoped=true&"
import script from "./ContributionPaymentSetup.vue?vue&type=script&lang=js&"
export * from "./ContributionPaymentSetup.vue?vue&type=script&lang=js&"
import style0 from "./ContributionPaymentSetup.vue?vue&type=style&index=0&id=745a9690&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "745a9690",
  null
  
)

export default component.exports